<template>
  <div>
    <b-form-input
      size="sm"
      type="text"
      v-model="innerValue"
      class="myInput" />
  </div>
</template>
<script>
import { mapMutations } from 'vuex';

export default {
  name: 'TextFilter',
  props: {
    value: {
      type: String,
      required: true
    },
    field: {
      type: String,
      required: true
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.setFilter({ key: this.field, value: val });
        if (val !== '') {
          this.$emit('filter', () => (x) => String(x[this.field])
            .toUpperCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .includes(val
              .toUpperCase()
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')));
        } else {
          this.$emit('filter', () => () => true);
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      setFilter: 'dataTableFilters/setFilter'
    })
  },
  mounted() {
    this.innerValue = this.$store.state.dataTableFilters.filters[this.field] || this.value;
  }
};
</script>
<style>

</style>
